import { ROUTES } from "@/utils/enums";

import useGettingStartedHidden from "./useGettingStartedHidden";

const useGetHomeRoute = () => {
  const gettingStartedHidden = useGettingStartedHidden();
  if (!gettingStartedHidden.value) {
    return ROUTES.GETTING_STARTED;
  }
  return ROUTES.TEAM_PROJECTS;
};

export default useGetHomeRoute;
